module.exports = __webpack_public_path__ + "static/media/loading2x.7648806c.gif";